// import OnboardingImg1 from '../features/onboarding/assets/bg-image.webp';
// import OnboardingImg2 from '../features/onboarding/assets/collect.svg';
// import OnboardingImg3 from '../features/onboarding/assets/draw.svg';
// import OnboardingImg4 from '../features/onboarding/assets/scan.svg';
// import OnboardingImg5 from '../features/onboarding/assets/track.svg';
// import OnboardingImg6 from '../features/onboarding/assets/tezos-logo.svg';
// import Artwork1 from '../assets/artworks/somfay.webp';
// import Artwork2 from '../assets/artworks/seton.webp';
// import Artwork3 from '../assets/artworks/imposter.webp';
// import Artwork4 from '../assets/artworks/goodman.webp';
// import Artwork5 from '../assets/artworks/sutu.webp';
// import Artwork6 from '../assets/artworks/swanson.webp';
// import Map from '../features/header/assets/map.png';
// import HeaderLogo from '../features/header/assets/tezos-logo.svg';
// import QuestionMark from '../features/header/assets/question.svg';
// import GroundDetect from '../features/tracking-overlay/assets/ground-detection.svg'

export const preloadSrcList: string[] = [
    // OnboardingImg1,
    // OnboardingImg2,
    // OnboardingImg3,
    // OnboardingImg4,
    // OnboardingImg5,
    // OnboardingImg6,
    // GroundDetect,
    // Artwork1,
    // Artwork2,
    // Artwork3,
    // Artwork4,
    // Artwork5,
    // Artwork6,
    // HeaderLogo,
    // QuestionMark,
    // Map,
];
